import QuoteInside from './QuoteInside'
export { QuoteInside }
export default QuoteInside
